import { mintSseTicket, sseUrlWithTicket } from './client';

export type SeatEvent =
  | { type: 'seat_held'; seat_id: number; by_me?: boolean }
  | { type: 'seat_released'; seat_id: number }
  | { type: 'seat_paid'; seat_id: number };

export function subscribeSession(sessionId: number | string, onEvent: (e: SeatEvent) => void) {
  let es: EventSource | null = null;
  let stopped = false;
  let retryTimer: number | null = null;

  const open = async () => {
    if (stopped) return;
    let ticket: string;
    try {
      ticket = await mintSseTicket();
    } catch {
      // Retry after a delay if we couldn't mint a ticket.
      if (!stopped) retryTimer = window.setTimeout(open, 2500);
      return;
    }
    if (stopped) return;
    const url = sseUrlWithTicket(`/api/sse/sessions/${sessionId}`, ticket);
    es = new EventSource(url);
    es.onmessage = (ev) => {
      try {
        const data = JSON.parse(ev.data);
        onEvent(data as SeatEvent);
      } catch {}
    };
    es.onerror = () => {
      es?.close();
      es = null;
      // Ticket is single-use — must mint a fresh one on reconnect.
      if (!stopped) retryTimer = window.setTimeout(open, 2500);
    };
  };
  void open();

  return () => {
    stopped = true;
    if (retryTimer) clearTimeout(retryTimer);
    es?.close();
  };
}
